import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../catalyst-components/table';
import { api } from '../../../../convex/_generated/api';
import { Id } from '../../../../convex/_generated/dataModel';
import { MainRoutes } from '../../../../shared/models';
import { Button } from '../../../../catalyst-components/button';
import { useNavigate } from 'react-router-dom';
import { useStableQuery } from '../../../../shared/hooks/useStableQuery';

interface CompletedSessionsTableProps {
    userId: Id<"users">;
}

export const CompletedSessionsTable: React.FC<CompletedSessionsTableProps> = ({ userId }) => {
    const navigate = useNavigate();

    const user = useStableQuery(api.users.getUserById, userId ? { 
        id: userId 
    } : "skip");

    const completedSessions = useStableQuery(api.completed_sessions.listByUser, userId ? { 
        user_id: userId 
    } : "skip") || [];

    return (
        <div className="mt-8">
            <h2 className="text-xl font-bold mb-4">Completed Sessions</h2>
            {completedSessions.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                    No completed sessions found for this user.
                </div>
            ) : (
                <Table striped className="w-full">
                    <TableHead className="border-b-2 border-primary-2">
                        <TableRow>
                            <TableHeader>Actions</TableHeader>
                            <TableHeader>Skill</TableHeader>
                            <TableHeader>Assistant</TableHeader>
                            <TableHeader>Completed</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {completedSessions.map((session) => (
                            <TableRow key={session._id} className="hover:bg-gray-50">
                                <TableCell>
                                    <Button
                                        color="light"
                                        onClick={() => navigate(`${MainRoutes.Chat}?sessionId=${session.session_id}&name=${user?.firstName} ${user?.lastName}&readonly=true`)}
                                    >
                                        View Chat
                                    </Button>
                                </TableCell>
                                <TableCell className="font-medium">{session.skill_name}</TableCell>
                                <TableCell className="font-medium">{session.assistant_name}</TableCell>
                                <TableCell className="text-sm text-gray-600">
                                    {session.completed_timestamp 
                                      ? new Date(session.completed_timestamp).toLocaleDateString()
                                      : 'N/A'
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </div>
    );
};